import { html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";

import styles from "./slide-anchor.css";

@customElement("bp-slide-anchor")
export class SlideAnchor extends LitElement {
  static styles = styles;

  @state()
  empty = true;

  @property({ type: Boolean, attribute: "show" })
  show = false;

  @property({ attribute: "slide-id" })
  slideId?: string;

  handleSlotchange({ target }: { target: HTMLSlotElement }) {
    this.empty = !this.show || !target.assignedNodes({ flatten: true }).length;
  }

  render() {
    return html`
      <a id="${ifDefined(this.slideId)}" data-empty="${this.empty}">
        <slot @slotchange=${this.handleSlotchange}></slot>
      </a>
    `;
  }

  scrollIntoView() {
    let previousElement;

    if (this.parentElement?.tagName && this.parentElement?.tagName === "P") {
      previousElement = this.parentElement.previousElementSibling;
    } else {
      previousElement = this.previousElementSibling;
    }

    const allowedSiblings = ["H1", "H2", "H3", "H4"];

    if (previousElement) {
      const scrollTarget = allowedSiblings.includes(previousElement.nodeName)
        ? previousElement
        : this.shadowRoot?.querySelector("a");

      scrollTarget?.scrollIntoView({ behavior: "smooth", inline: "nearest" });
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-slide-anchor": SlideAnchor;
  }
}
